import Marquee from "react-fast-marquee";
import { TICKER_ITEMS } from "@/data/news";

export const Ticker = () => (
  <div data-testid="breaking-ticker" className="bg-[#4ADE80] border-y border-black/20 relative z-20">
    <Marquee speed={40} gradient={false} pauseOnHover>
      {TICKER_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-mono-news text-xs sm:text-sm font-medium text-black uppercase tracking-widest py-3">
            {item}
          </span>
          <span className="mx-8 text-black/50 text-xs">◆</span>
        </span>
      ))}
    </Marquee>
  </div>
);
